import { render, staticRenderFns } from "./ResumeAndSubmit.vue?vue&type=template&id=797e35f4&scoped=true&"
import script from "./ResumeAndSubmit.vue?vue&type=script&lang=js&"
export * from "./ResumeAndSubmit.vue?vue&type=script&lang=js&"
import style1 from "./ResumeAndSubmit.vue?vue&type=style&index=1&id=797e35f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797e35f4",
  null
  
)

/* custom blocks */
import block0 from "./ResumeAndSubmit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports